// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 132) return "static/chunks/a5d1118a-4e18abbf46a2cd60.js";
	if (chunkId === 423) return "static/chunks/423-56f023cd8be28df9.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"985c0bd6ff06b159","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"2bd00f69b7ee0b23","367":"88bbe02cfa92a70d","639":"e7b660adfa99260e","748":"708b0ce6c5a9651c"}[chunkId] + ".js";
};